export const ORIGEN_DOCUMENTO_ENUM = {
  NO_ESPECIFICADO: 0,
  EDI: 1,
  FACE: 2,
  OPS: 3,
  ERP: 4,
  VUZOON_FREE_FACTURA: 5,
  OCR: 6,
  INTEGRACION_SAGE: 7,
  ERP_IMPORTACION_EXCEL: 8,
  ERP_DOCUMENTO_RECURRENTE: 9,
  ERP_IMPORTACIONFACTURAE: 10,
} as const

export type OrigenDocumentoEnumType =
  (typeof ORIGEN_DOCUMENTO_ENUM)[keyof typeof ORIGEN_DOCUMENTO_ENUM]
